import { IPublicClientApplication } from "@azure/msal-browser";
import { apiLoginRequest } from "../Config";
import { SupplierModel } from "../Models/SupplierModel";
import SupplierProjectMailModel from "../Models/SupplierProjectMailModel";

export default class SupplierService {
  msalInstance: IPublicClientApplication;

  constructor(msalInstance: IPublicClientApplication) {
    this.msalInstance = msalInstance;
  }

  public async getAll(): Promise<SupplierModel[]> {
    const baseUrl = process.env.REACT_APP_API_URL;
    const accessToken = await this.acquireAccessToken();

    const records = await fetch(baseUrl + "/api/Suppliers", {
      method: "get",
      headers: new Headers({
        Authorization: "Bearer " + accessToken,
      }),
    }).then(function (response) {
      return response.json();
    });

    return records;
  }

  public async upsert(toUpdate: SupplierModel[]) {
    const baseUrl = process.env.REACT_APP_API_URL;
    const accessToken = await this.acquireAccessToken();

    const records = await fetch(baseUrl + "/api/Suppliers", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + accessToken,
      }),
      body: JSON.stringify(toUpdate),
    }).then(function (response) {
      return response.json();
    });
    return records;
  }

  public async getMailsSentForSupplier(
    code: string
  ): Promise<SupplierProjectMailModel[]> {
    const baseUrl = process.env.REACT_APP_API_URL;
    const accessToken = await this.acquireAccessToken();

    const records = await fetch(
      baseUrl + `/api/SupplierProjectMails?code=${code}`,
      {
        method: "get",
        headers: new Headers({
          Authorization: "Bearer " + accessToken,
        }),
      }
    ).then(function (response) {
      return response.json();
    });
    return records;
  }

  private async acquireAccessToken() {
    const account = this.msalInstance.getActiveAccount();
    if (!account) {
      throw Error(
        "No active account! Verify a user has been signed in and setActiveAccount has been called."
      );
    }

    const authResult = await this.msalInstance.acquireTokenSilent({
      ...apiLoginRequest,
      account: account,
    });

    return authResult.accessToken;
  }
}
